define('models/Eligibility',[
    'core/can',
    'models/Session',
    'models/Base',
    'models/PatientStatus',
    'moment'
], function (can, Session, Base, PatientStatus, moment) {

    var EpisodePeriod = can.Model.extend({

        _PatientStatusCode: can.compute(function () {
            var v = this.attr('PatientStatus'), o = PatientStatus[v];
            return (o !== undefined) ? o.code : undefined;
        }),

        _PatientStatusDescription: can.compute(function () {
            var v = this.attr('PatientStatus'), o = PatientStatus[v];
            return (o !== undefined) ? o.desc : undefined;
        }),

        _PatientIndicator: can.compute(function () {
            switch (this.attr('PatientIndicator')) {
                case 0: return 'Episode in good status, Final claim received on time';
                case 1: return 'RAP auto canceled';
                case 2: return 'RAP not canceled, Final claim denied by Medical Review, entire episode canceled';
            }
        }),

        _ProviderInformation: can.compute(function () {
            var npi = this.attr('MedicareProviderNumber'),
                providers = Session.attr('Providers'),
                providerPhoneNumber = this.attr('ProviderPhoneNumber'),
                providerAddress = this.attr('ProviderAddress'),
                providerName = null,
                providerInformation = providerName;
            for (var i=0; i<providers.attr('length'); i++) {
                if (providers.attr(i).attr('Npi') === npi) {
                    providerInfo = providers.attr(i)
                    providerPhoneNumber = providerInfo.attr('Phone'),
                    providerAddress = providerInfo.attr('Address'),
                    providerName = providerInfo.attr('Name'),
                    providerInformation = providerName;
                    break;
                }
            }

            if (providerName !== undefined && providerName !== null) {
                if (providerAddress !== undefined && providerAddress !== null && providerAddress.attr('Line1' !== null)) {
                    providerInformation += '<br>Address:<br>';
                    providerInformation += providerAddress.attr('Line1') + '<br>' + providerAddress.attr('City') + ', ' + providerAddress.attr('State') + '<br>' + providerAddress.attr('ZipCode');

                    if (providerAddress.attr('ZipCodeExt')) {
                        providerInformation += '-' + providerAddress.attr('ZipCodeExt');
                    }
                }

                if (providerPhoneNumber !== undefined && providerPhoneNumber !== null) {
                    providerInformation += '<br>Phone: ';
                    providerInformation += '(' + providerPhoneNumber.substr(0, 3) + ') ' + providerPhoneNumber.substr(3, 3) + '-' + providerPhoneNumber.substr(6, 4);
                }
            } else {
                providerInformation = "N/A"
            }
            return providerInformation;
        }),

        _isOtherHHA: can.compute(function () {
            var NPI = this.attr('NPI');
            return !Session.attr('Providers').filter(function (p) {
                return p.attr('Npi') === NPI;
            }).length;
        })
    }),

        MSPPeriod = can.Model.extend({

            _ProvisionsCode: can.compute(function () {
                switch (this.attr('Provisions')) {
                    case 0: return '?';
                    case 1: return 'A';
                    case 2: return 'B';
                    case 3: return 'D';
                    case 4: return 'E';
                    case 5: return 'F';
                    case 6: return 'G';
                    case 7: return 'H';
                    case 8: return 'I';
                    case 9: return 'L';
                    case 10: return 'W';
                }
            }),

            _ProvisionsDescription: can.compute(function () {
                switch (this.attr('Provisions')) {
                    case 0: return 'Not Specified';
                    case 1: return 'Working Aged';
                    case 2: return 'ESRD';
                    case 3: return 'No-Fault';
                    case 4: return 'Workers\' Compensation';
                    case 5: return 'PHS Other Federal Agency';
                    case 6: return 'Disability';
                    case 7: return 'Black Lung';
                    case 8: return 'Veterans (V A)';
                    case 9: return 'Liability';
                    case 10: return 'Workers\' Compensation set aside';
                }
            })
        }),

        MedicareAdvantagePlan = can.Model.extend({

            _PlanType: can.compute(function () {
                switch (this.attr('PlanType')) {
                    case 0: return 'Not Specified';
                    case 1: return 'HMO';
                    case 2: return 'PPO';
                    case 3: return 'PFFS';
                }
            }),

            // - Unrestricted
            // 1 = Intermediary to process all Part A and Part B provider claims
            // 2 = MA Plan to process claims for directly provided services from providers with effective arrangements, intermediary to process all other claims
            // - Restricted
            // A = Intermediary to process all claims.
            // B = MA Plan to process claims for directly provided services.
            // C = MA Plan to process all claims.

            _OptionCode: can.compute(function () {
                switch (this.attr('OptionCodes')) {
                    case 0: return undefined; // Not Specified
                    case 1: return '1';
                    case 2: return '2';
                    case 3: return 'C';
                }
            }),

            _OptionCodeDescription: can.compute(function () {
                switch (this.attr('OptionCodes')) {
                    case 0: return undefined; // Not Specified
                    case 1: return 'Intermediary to process all Part A and Part B provider claims.';
                    case 2: return 'MA Plan to process claims for directly provided services from providers with effective arrangements, intermediary to process all other claims.';
                    case 3: return 'MA Plan to process all claims.';
                }
            })
        }),

        HospitalBenefitPeriod = can.Model.extend({
            define: {
                InpatientDeductible: {
                    type: 'number'
                },
                BloodDeductible: {
                    type: 'number'
                }
            }
        }),

        makeGenderCompute = function (key) {
            return can.compute(function () {
                switch (this.attr(key)) {
                    case 0: return 'Male';
                    case 1: return 'Female';
                    case 2: return 'Unknown';
                    default: return undefined;
                }
            });
        },
        // CONFIRM Looks like this function is not being used.
        makeHasCompute = function (key) {
            return can.compute(function () {
                var list = this.attr(key);
                if (list) {
                    for (var i = 0; i < list.attr('length'); i++) {
                        var period = list.attr(i),
                            start = period.attr('StartDate'),
                            end = period.attr('EndDate');
                        if (start && (end === null || moment.utc(end).isAfter())) {
                            return true;
                        }
                    }
                }
                return false;
            })
        };

    var Eligibility = Base.extend({

        findAll: 'GET /Eligibility/List',
        findOne: 'GET /Eligibility/{id}',
        create: 'POST /Eligibility',
        update: 'PUT /Eligibility/{id}',
        destroy: 'DELETE /Eligibility/{id}',

        findLatestByPatient: function (params, success, error) {
            return can.ajax({
                type: 'GET',
                url: '/Patient/{id}/Eligibility',
                data: params
            })
                .then(can.proxy(this.models, this))
                .then(success, error);
        }

    }, {

            define: {
                EpisodePeriods: {
                    Type: EpisodePeriod.List
                },
                MspPeriods: {
                    Type: MSPPeriod.List
                },
                MedicareAdvantagePlans: {
                    Type: MedicareAdvantagePlan.List
                },
                PriorHospitalBenefitPeriod: {
                    Type: HospitalBenefitPeriod
                },
                CurrentHospitalBenefitPeriod: {
                    Type: HospitalBenefitPeriod
                }
            },

            _lastName: can.compute(function () {
                var fullName = this.attr('Fullname');
                return (!!fullName && fullName.includes('.')) ? fullName.split(".")[0] : this.attr('SearchLastName');
            }),

            _firstName: can.compute(function () {
                var fullName = this.attr('Fullname');
                // Below check is a result of several instances of fullName being a string with only a space in it
                if (!fullName ||!fullName.trim()) {
                    return this.attr('SearchFirstInitial');
                } else {
                    if (fullName.includes('.')) {
                        return fullName.split('.')[1];
                    } else if (fullName.includes(' ')) {
                        var lastName = this.attr('SearchLastName');
                        var substringToRemove = ' ' + lastName;
                        var firstName= fullName.replace(substringToRemove, '');
                        return firstName;
                    }
                }
                return '';
            }),

            /*_middleInitial: can.compute(function() {
                var fullName = this.attr('Fullname');
                return (fullName !== undefined && fullName !== null) ? fullName.split(".")[2] : undefined;
            }),*/

            // 0 Created
            // 1 Processing
            // 2 Pending
            // 3 Success
            // 5 Errored
            // 7 Unknown

            _isPending: can.compute(function () {
                return this.attr('Status') === 0 || this.attr('Status') === 1 || this.attr('Status') === 2;
            }),

            _isReady: can.compute(function () {
                return this.attr('Status') === 3;
            }),

            _isErrored: can.compute(function () {
                return this.attr('Status') === 5 || this.attr('Status') === 7;
            }),


            _SearchGender: makeGenderCompute('SearchGender'),

            _CorrectGender: makeGenderCompute('CorrectGender'),

            _DispositionCode: can.compute(function () {
                switch (this.attr('DispositionCode')) {
                    case '01': return 'Part A Inquiry approved';
                    case '02': return 'Part A Inquiry approved';
                    case '03': return 'Part A Inquiry rejected';
                    case '20': return 'Qualified approval but may require further investigation';
                    case '25': return 'Qualified approval';
                    case '50': return 'Not in file';
                    case '51': return 'Not in file on CMS batch system';
                    case '52': return 'Master record housed at another HOST site';
                    case '53': return 'Not in file in CMS but sent to CMS\'s alpha-reinstate';
                    case '55': return 'Does not match a master record';
                    case 'ER': return 'Consistency edit reject';
                    case 'UR': return 'Utilization edit';
                    case 'CR': return 'A/B crossover edit';
                    case 'CI': return 'CICS processing problem';
                    case 'SV': return 'Security violation';
                }
            }),

            _hasPartAorB: can.compute(function () {
                return this.attr('HasPartA')
                    || this.attr('HasPartB');
            }),

            _hasHospitalBenefitPeriods: can.compute(function () {
                var current = this.attr('CurrentHospitalBenefitPeriod').attr(),
                    prior = this.attr('PriorHospitalBenefitPeriod').attr();
                return !can.$.isEmptyObject(current) || !can.$.isEmptyObject(prior);
            }),

            _hasIssues: can.compute(function () {
                return this.attr('HasHmo')
                    || this.attr('HasHospice')
                    || this.attr('HasMsp')
                    || this.attr('HasOtherHha');
            })
        });

    Eligibility.prototype.rules = {
        SearchHicNumber: {
            validators: {
                notEmpty: {
                    message: 'HIC number is required.'
                },
                regexp: {
                    regexp: /^[a-z0-9]+$/i,
                    message: 'Hic number can only contain alphanumeric characters.'
                }
            }
        },
        SearchLastName: {
            validators: {
                notEmpty: {
                    message: 'Last Name is required.'
                },
                regexp: {
                    regexp: /^[a-z]+(\s+[a-z]+)*$/i,
                    message: 'Last Name can only contain alphabetical characters.'
                }
            }
        },
        SearchFirstInitial: {
            validators: {
                notEmpty: {
                    message: 'First Initial is required.'
                },
                regexp: {
                    regexp: /^[a-z]+$/i,
                    message: 'First Initial must be an alphabetical character.'
                }
            }
        },
        SearchDOB: {
            validators: {
                notEmpty: {
                    message: 'Date of Birth is required.'
                },
                date: {
                    message: 'Date of Birth must be a valid date.'
                }
            }
        },
        SearchGender: {
            validators: {
                notEmpty: {
                    message: 'Gender is required.'
                }
            }
        }
    };

    Eligibility.List.prototype.getMostRecent = function () {
        for (var i = 0; i < this.attr('length'); i++) {
            if (this.attr(i).attr('_isReady')) {
                return this.attr(i);
            }
        }
    }

    return Eligibility;

});
